import React, { useEffect } from "react";
import ConvenienceSection from "./ConvenienceSection";
import Home from "./Home";
import HowItWorks from "./HowItWorks";
import SecureTransfer from "./SecureTransfer";
import TransferDestinations from "./TransferDestinations";
import CustomerExperience from "./CustomerExperience";

function FrontPage(props) {
  const { homeRef, sendRef, howRef, handleScroll } = props;

  const scrollToSendSection = () => {
    sendRef.current.scrollIntoView(true);
  };

  useEffect(() => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0;
  }, []);

  return (
    <div>
      <Home homeRef={homeRef} sendRef={sendRef} onScroll={handleScroll} />
      <ConvenienceSection />
      <div className="container pt-5" ref={howRef}>
        <HowItWorks />
        <SecureTransfer />
      </div>
      <div className="container">
        <TransferDestinations onClick={scrollToSendSection} pageType="home" />
      </div>
      <CustomerExperience onClick={scrollToSendSection} />
    </div>
  );
}

export default FrontPage;
